import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { userService } from "../../_services";
import SignupHeader from "./signup_header";
import Signupleft from "../../images/signupleft.webp";
import signupcheck from "../../images/savecheck.png";

const Activate_SecAccount = () => {
    const [activationStatus, setActivationStatus] = useState('');
    const [activationStatusMessage, setActivationStatusMessage] = useState('');

    useEffect(() => {
        setTimeout(() => {
            try {
                const params = window.location.search.replace('?secuid=', '');
                const arr = params.split('/');
                let emailcode = '';
                let _Arr = params.split('/');
                for (let i = 0; i < arr.length - 1; i++) {
                    if (emailcode === '') {
                        emailcode = arr[i];
                    } else {
                        emailcode = emailcode + '/' + arr[i];
                    }
                }
                var objectUid = _Arr[_Arr.length - 1];
                // Strip any tracking params appended by email providers (e.g. &utm_source=brevo...)
                if (objectUid.indexOf('&') !== -1)
                    objectUid = objectUid.substring(0, objectUid.indexOf('&'));
                //this.activateUserAccount_secLink(emailcode, objectUid);
                activateUserAccountSecLink(emailcode, objectUid);
            } catch (err) {
                console.error('Activation error:', err);
            }
        }, 1000);
    }, []);

    const activateUserAccountSecLink = async (EmailId, ObjectUid) => {
        try {
            const apidata = await userService.ActivateAccount_secLink(EmailId, ObjectUid);
            
            if (apidata.length > 0) {
                if (apidata[0].code === "1") {
                    setActivationStatus(apidata[0].code);
                    setActivationStatusMessage(apidata[0].message);
                } else {
                    setActivationStatus(apidata[0].message);
                    setActivationStatusMessage(apidata[0].message);
                }
            } else {
                setActivationStatus('-1');
            }
        } catch (error) {
            setActivationStatus('-1');
        }
    };

    return (
        <div className="min-h-screen bg-secondary">
            <SignupHeader />
            
            <div className="w-full mx-auto">
                <div className="flex items-center justify-center min-h-[calc(100vh-80px)]">
                    <div className="w-full max-w-[1260px] mx-auto px-4 md:px-8">
                        <div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-16">
                            {/* Left side - Image */}
                            <div className="flex-1 flex items-center justify-center md:max-w-[689px]">
                                <img 
                                    src={Signupleft} 
                                    alt="Account Activation" 
                                    className="w-full h-auto object-contain"
                                />
                            </div>

                            {/* Right side - Activation Status */}
                            <div className="flex-1 flex items-center justify-center md:max-w-[490px]">
                                <div className="w-full space-y-6 text-center">
                                    {activationStatus === '' ? (
                                        // Loading State
                                        <div className="space-y-4">
                                            <p className="text-lg text-foreground">
                                                Please wait while your request is processing
                                                <span className="inline-flex ml-1">
                                                    <span className="animate-bounce delay-0">.</span>
                                                    <span className="animate-bounce delay-100">.</span>
                                                    <span className="animate-bounce delay-200">.</span>
                                                </span>
                                            </p>
                                        </div>
                                    ) : activationStatus === '-1' ? (
                                        // Error State
                                        <div className="space-y-4">
                                            <p className="text-lg text-foreground">
                                                Account error, Invalid request parameters.
                                            </p>
                                        </div>
                                    ) : (
                                        // Success State
                                        <>
                                            <div className="flex justify-center mb-6">
                                                <img 
                                                    src={signupcheck} 
                                                    alt="Success" 
                                                    className="w-32 h-32 object-contain"
                                                />
                                            </div>
                                            <div className="space-y-4">
                                                <p className="text-lg text-foreground">
                                                    {activationStatusMessage}
                                                </p>
                                            </div>
                                            <div className="pt-4">
                                                <Link to="/login">
                                                    <Button 
                                                        variant="secondary"
                                                        size="lg" 
                                                        className="w-auto"
                                                    >
                                                        Sign In Now
                                                    </Button>
                                                </Link>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Activate_SecAccount;
